<div class="tabs">
  <span (click)="setMediaFilter('all')" [class.active]="mediaFilter==='all'">All</span>
  <span (click)="setMediaFilter('photos')" [class.active]="mediaFilter==='photos'">Photos</span>
  <span (click)="setMediaFilter('videos')" [class.active]="mediaFilter==='videos'">Videos</span>
</div>

<div class="user-grid-section mt-4">
  @for (announcement of filteredAnnouncements; track announcement) {
  <!-- ✅ Only show card if filtered files exist -->
  @if (filterFiles(announcement.files).length > 0) {
  <div class="user-grid-card">
    <div class="media-wrapper">
      <div class="image-wrapper">
        @for (file of filterFiles(announcement.files); track file; let i = $index) {
        <!-- If it's an image -->
        @if (isImage(file)) {
        <img [src]="file" alt="Announcement" class="media" (click)="openSlider(filterFiles(announcement.files), i)" />
        }
        <!-- If it's a video -->
        @if (isVideo(file)) {
        <video [src]="file" controls class="media" (click)="openSlider(filterFiles(announcement.files), i)"></video>
        }
        }
      </div>
    </div>
    <div class="user-info">
      <h2>{{ announcement.title }}</h2>
    </div>
  </div>
  }
  }
</div>


<!-- 🔥 Slider Modal -->
@if (sliderOpen) {
<div class="slider-overlay">
  <button class="close-btn" (click)="closeSlider()">X</button>
  <!-- Active media -->
  <div class="slider-content">
    @if (isImage(activeFile)) {
    <img [src]="activeFile" alt="active" />
    }
    @if (isVideo(activeFile)) {
    <video [src]="activeFile" controls></video>
    }
  </div>
  <!-- ✅ Thumbnails: only filtered files -->
  <div class="thumbnails">
    @for (file of sliderFiles; track file; let i = $index) {
    <div class="thumb-wrapper" [class.active-thumb]="i === activeIndex" (click)="setActive(i)">
      @if (isImage(file)) {
      <img [src]="file" alt="thumb" />
      }
      @if (isVideo(file)) {
      <video [src]="file" muted></video>
      }
    </div>
    }
  </div>
  <!-- Navigation -->
  <button class="nav-btn prev" (click)="prevFile()">‹</button>
  <button class="nav-btn next" (click)="nextFile()">›</button>
</div>
}